import gsap from 'gsap'

import { PAGE_TRANSITION_ENTER_DELAY } from '@/contexts/transition'
import { MediaQuery } from '@/constants'

import {
  getScrollTriggerHorizontalOptions,
  getScrollTriggerVerticalOptions,
  isElementInViewport
} from './utils'
import { Animation } from '@/types'

export const doubleImageRevealAnimation = ({
  node,
  reverse,
  context
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const wrapper = selector('[data-motion-wrapper]')
  const content = selector('[data-motion-content]')

  const matchMedia = gsap.matchMedia(node)

  matchMedia.add(MediaQuery.SMALL, () => {
    const inView = isElementInViewport(node, false)

    gsap
      .timeline({
        ...getScrollTriggerVerticalOptions(node, reverse, 'top 100%'),
        delay: inView ? PAGE_TRANSITION_ENTER_DELAY : 0
      })
      .fromTo(
        wrapper,
        { scale: 0.4, rotate: -20 },
        {
          scale: 1,
          rotate: 0,
          duration: 1,
          stagger: 0.12,
          ease: 'power3.out'
        }
      )
      .fromTo(
        content,
        { scale: 1.5, rotate: 20 },
        {
          scale: 1,
          rotate: 0,
          duration: 1,
          stagger: 0.12,
          ease: 'power3.out'
        },
        '<'
      )
  })

  matchMedia.add(MediaQuery.LARGE, () => {
    const inView = isElementInViewport(node, true)

    gsap
      .timeline({
        ...getScrollTriggerHorizontalOptions(node, reverse, 'left 100%'),
        delay: inView ? PAGE_TRANSITION_ENTER_DELAY : 0
      })
      .fromTo(
        wrapper,
        { scale: 0.4, rotate: -20 },
        {
          scale: 1,
          rotate: 0,
          duration: 1,
          stagger: 0.12,
          ease: 'power3.out'
        }
      )
      .fromTo(
        content,
        { scale: 2.5, rotate: 20 },
        {
          scale: 1,
          rotate: 0,
          duration: 1,
          stagger: 0.12,
          ease: 'power3.out'
        },
        '<'
      )
  })

  return () => {
    matchMedia.revert()
  }
}
